import "./ToastHostedCheckout.scss";

import React from "react";
import { useSelector } from "react-redux";
import { Button } from "src/sharedComponents";
import { getAllHostedFieldsValid } from "src/features/paymentMethods/selectors/hostedFields";
import { AddCardFormProps } from "src/features/paymentMethods/components/AddCardForm";

export const ToastHostedCheckout = ({ onAdd }: Pick<AddCardFormProps, "onAdd">) => {
    const isValid = useSelector(getAllHostedFieldsValid);

    if (!onAdd) return null;

    return (
        <div className="payment-method__add-card__footer">
            <Button value="Save card" disabled={!isValid} onClick={onAdd} />
        </div>
    );
};
